<mat-dialog-title style="padding: 8px 12px;">
  <div class="dialog-title-container">
    <h2 class="title">Upload Additional Document</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
</mat-dialog-title>

<mat-dialog-content class="dialog-container">
  <div class="content">
    <div class="upload-container">
      <div class="upload-box" [class.disabled]="selectedFiles.length > 0">
        <input id="fileUpload" type="file" (change)="onFilesSelected($event)" class="file-input" accept=".pdf,.png"
          [disabled]="selectedFiles.length > 0" />

        <div *ngIf="selectedFiles.length === 0" class="upload-placeholder">
          <div class="upload-icon-container">
            <img src="assets/images/uploadicon.svg" alt="Upload Icon" />
            <p>Drag or click to upload documents here</p>
            <small>(Supported file types: PDF, PNG)</small>
          </div>
        </div>

        <div class="uploaded-files" *ngIf="selectedFiles.length > 0">
          <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
            <div class="file-preview">
              <img *ngIf="file.type === 'image'" [src]="file.preview" alt="{{ file.name }}" />
              <mat-icon *ngIf="file.type !== 'image'">description</mat-icon>
            </div>
            <div class="file-details">
              <p class="file-name">{{ file.name }}</p>
            </div>
            <button mat-icon-button class="remove-button" (click)="removeFile(i)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="actions">
      <button class="button-Primary" (click)="upload()">UPLOAD</button>
    </div>
  </div>
</mat-dialog-content>